<template>
  <div>

        <el-table size="mini" v-loading="tableLoading"  :data="tableData" :height="230" border>
          <el-table-column prop="value" label="血糖"></el-table-column>
          <el-table-column prop="createTime" label="时间" :formatter="timefilter"></el-table-column>
        </el-table>

        <div class="page" style="padding-top: 5px;">
          <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination small
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="20"
                :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>


          <download-excel
              class = "export-excel-wrapper"
              :fetch           = "fetchData"
              :fields          = "json_fields"
              :before-generate = "startDownload"
              :before-finish   = "finishDownload"
              name = "血糖.xls"
              style="float: right">
            <el-button type="primary" size="mini" icon="el-icon-download" plain>导出</el-button>
          </download-excel>


          <div style="clear: both;"></div>
        </div>


    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
      </div>
    </div>

  </div>
</template>

<script>




import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "BloodPressureAndHeartRate",
  data() {
    return {
      tableLoading:false,
      userDeviceCode: '',
      userCode: '',

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,


      showModal:false,
      json_fields: {
        "用户名": "userName",
        "血糖": "value",
        "监测时间": {
          field:"createTime",
          callback:value=>{
            return timefilters(value);
          }
        },

      },



    }
  },
  components: {

  },

  methods: {
    init(userDeviceCode) {
      this.userDeviceCode = userDeviceCode;
      this.getListXueYaXinLvByPhone();
    },
    init2(userDeviceCode,userCode) {
      this.userDeviceCode = userDeviceCode;
      this.userCode = userCode;
      this.getList();
    },
    closeSelf() {
      this.$emit("closeBlood");
    },


    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){
      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "DataAll/PageByUserCodeDeviceTypeValueType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userCode: this.userCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          deviceType: 'h09',
          valueType: 5,
        }
      }).then(
          (response) => {
            this.tableLoading=false
            if (response.data.error === 0) {
              this.tableData=response.data.data.pageInfo.list;
              this.totalItems=response.data.data.pageInfo.total;
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },


    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    async fetchData(){

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        userCode: this.userCode,
        pageIndex:1,
        pageSize:99999,
        deviceType: 'h09',
        valueType: 5,
      }

      const response = await this.$axios.post(this.$deviceUrl+"DataAll/PageByUserCodeDeviceTypeValueType",data);
      return response.data.data.pageInfo.list;
    },

    startDownload:function (){
      this.showModal = true;
    },

    finishDownload:function (){
      this.showModal = false;
    },


  }


}
</script>

<style lang="scss" scoped>


</style>
